import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import toastr from '../toastr';
import browserHistory from '../../history';
import Api from '../../services/ApiService';
import PrintJobEdit from './PrintJobEdit';

class PrintJobEditContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      payload: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { id } = this.state;

    Api.get(`print/job/${id}/payload`).then(({ data }) => {
      this.setState({ payload: data.payload });
    });
  }


  handleSubmit(payload) {
    if (JSON.stringify(this.state.payload, null, 2) === payload) {
      toastr.warning('JSON unchanged');
      return Promise.reject();
    }

    try {
      payload = JSON.parse(payload);
      return Api.post('print', payload).then(({ data }) => {
        if (_.isString(data)) {
          // likely a screen job
          browserHistory.push('/UPD1');
        } else {
          browserHistory.push(`/UPD1/${data.printJob.id}`);
        }
      });
    } catch (err) {
      toastr.error(err.message);
      return Promise.reject();
    }
  }

  render() {
    const { id, payload } = this.state;

    if (!payload) {
      return null;
    }

    return (
      <PrintJobEdit
        id={id}
        payload={payload}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

PrintJobEditContainer.propTypes = {
  match: PropTypes.object,
};

export default PrintJobEditContainer;
